<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ action !== 'edit' ? $t(`${namespace}.paymentMethod`) : $t(`${namespace}.changePaymentMethod`) }}
      </v-flex>
    </v-layout>

    <v-tooltip
      v-if="hasRole('billing', 'ROLE_PUT_CREDIT_CARD') && action === 'preview'"
      max-width="177"
      top
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          @click="handleEditProject"
        >
          <v-icon color="gray-6">edit</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Common.edit') }}</span>
    </v-tooltip>

    <v-btn icon @click="close()">
      <v-icon color="gray-6">close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    action: {
      type: String,
      required: true
    },

    paymentMethod: {
      type: String
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.paymentMethod.header'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    handleEditProject () {
      const action = this.paymentMethod === 'CREDIT_CARD' ? 'edit' : 'editConfirm'
      this.$emit('toggleAction', action)
    }
  }
}
</script>
